import * as React from "react";
import { Grid } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { ResponsiveAppBar } from "./index";
import MiniDrawer from "./MiniDrawer";
import Corrispondente from "../pages/Corrispondente";

//11/07/2026 Switch di route per /corrispondente e /vettore.
//Se l'URL contiene ?id=<token> (link monouso Transmart) la pagina viene montata in
//layout pubblico (senza MiniDrawer, quindi senza guardia di login) e il token viene
//propagato alla pagina; altrimenti resta il comportamento autenticato di sempre.
const CorrispondenteRouteSwitch = ({ titoloPassato }) => {
  const [searchParams] = useSearchParams();
  const signedLinkToken = searchParams.get("id");

  if (signedLinkToken) {
    return (
      <Grid container spacing={2}>
        <ResponsiveAppBar />
        <Grid item xs={12} md={12} lg={12} m={10}>
          <Corrispondente signedLinkToken={signedLinkToken} />
        </Grid>
      </Grid>
    );
  }

  return (
    <MiniDrawer child={<Corrispondente />} titoloPassato={titoloPassato} />
  );
};

export default CorrispondenteRouteSwitch;
